// Template consumed at deploy time by .github/workflows/build-deploy.yml (sed placeholder
// replacement — same pattern as document-service-frontend's cd.yml). Copied to
// environment.{gh-environment}.ts, placeholders replaced from GitHub Actions secrets scoped to
// the target GitHub Environment (aws-die / aws-silver / aws-gold / aws-prod), then compiled in
// via the matching angular.json fileReplacements configuration.
export const environment = {
	useProxy: false,
	production: true,
	msalConfig: {
		auth: {
			clientId: 'efd588a9-0192-4b59-a3d7-38635d1d4be6',
			authority: 'https://login.microsoftonline.com/3f998017-0d99-4e9a-ae46-fb070d03b2cc',
			redirectUri: 'https://frontend.beproductcatalogsilver.alzp.tgscloud.net/auth-callback'
		}
	},
	apiConfig: {
		scopes: ['api://efd588a9-0192-4b59-a3d7-38635d1d4be6/ProductCatalog.Admin.All'],
		uri: 'https://graph.microsoft.com/v1.0/me'
	}
};

